import { API_URLS } from "src/api/api-urls";
import useApiServices from "src/api/use-api-services";
import { filtersDefaultValues } from "src/constants/filters-default-values";
import { NYCTimesDtoType } from "src/types/platforms/nyc-times";
import { DashboardType } from "src/types/types";
import { useQueryParams } from "use-query-params";

const useNYCTimesDashboardView = ({ type }: { type: DashboardType }) => {
  // #region States and hooks
  const { useGetListApi } = useApiServices();

  // Get filters default from url params if available
  const [query] = useQueryParams(filtersDefaultValues);
  // #endregion States and hooks

  // #region Services
  // Get charts data and analysis
  const {
    data: platformData,
    isLoading: isDataLoading,
    error,
  } = useGetListApi<NYCTimesDtoType>({
    url: API_URLS[type].NYC_TIMES.ANALYSIS,
    parameters: {
      keyword: query.keyword,
      sentiment: query.sentiment,
      language: query.language,
      start_date: query.start_date,
      end_date: query.end_date,
    },
  });

  // #endregion Services

  return {
    platformData,
    isDataLoading,
    error,
  };
};

export default useNYCTimesDashboardView;
